import { useEffect } from "react";
import NetInfo from "@react-native-community/netinfo";
import Toast from "react-native-toast-message";
import { Platform } from "react-native";

const useInternetConnectionListener = () => {
  useEffect(() => {
    if (Platform.OS !== "web") {
      NetInfo.configure({
        reachabilityUrl:
          "https://illuminex-prod-customization-data.s3.amazonaws.com/customization_without_product_type/unified_page/Organization/1.json",
        reachabilityTest: async (response) => response.status === 200,
        reachabilityLongTimeout: 60 * 1000,
        reachabilityShortTimeout: 20 * 1000,
        reachabilityRequestTimeout: 15 * 1000,
        reachabilityShouldRun: () => true,
        shouldFetchWiFiSSID: true,
        useNativeReachability: false,
      });
    }

    const unsubscribe = NetInfo.addEventListener((state) => {
      if (state.isConnected) {
        Toast.hide();
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);
};

export default useInternetConnectionListener;
